// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"4fee4320","156":"24b0b988","237":"3f26b37b","723":"24b0b988","888":"e2e04d7a"}[chunkId] + ".css";
};